import { environment as baseEnv } from './environment.base';
export const environment = {
  ...baseEnv,
  production: false,
  app_version: 'dev',
  env: 'dev',
  ws_ping_interval: 60000,
  ws_reconnect_interval: 5000,
  api_url: 'https://services.dev.epione.net/live-feeds',
};
